<template>
  <v-dialog
    id="closingProcessDialog"
    :value="enableDialog"
    persistent
    width="800"
    @keydown.esc="cancelButtonClickEvent"
    @close="cancelButtonClickEvent"
  >
    <validation-observer ref="closingProcessFormValidator">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>
            本締め処理
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <div class="mx-4 my-5 gray--text">
            請求情報の本締め処理（データの確定）を行います。<br />
            ※ステータスが「仮締め」の請求情報について本締め処理を行います。<br />
            ※本締め処理を行うと請求金額の変更は行えませんのでご注意ください。
          </div>
          <v-form>
            <!-- 請求月度, 締め日 -->
            <v-row>
              <v-col cols="12" md="6">
                <cs-date-picker
                  :date.sync="forms.billing_month"
                  type="month"
                  @dateChangedCallback="billingMonthChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <validation-provider
                      v-slot="{ errors }"
                      class="requiredMark"
                      rules="required"
                      name="請求月度"
                    >
                      <v-text-field
                        v-model="forms.billing_month"
                        v-bind="attrs"
                        v-on="on"
                        :error-messages="errors"
                        append-icon="mdi-calendar"
                        dense
                        hide-details="auto"
                        label="請求月度"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        readonly
                      />
                    </validation-provider>
                  </template>
                </cs-date-picker>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  rules="required"
                  name="締め日"
                >
                  <v-select
                    v-model="forms.closing_date_type"
                    :error-messages="errors"
                    :items="closingDateTypes"
                    dense
                    hide-details="auto"
                    label="締め日"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /請求月度, 締め日 -->

            <!-- 請求先 -->
            <v-row>
              <v-col cols="12" md="12">
                <infinite-billing-auto-complete
                  :billing-id="forms.billing_address_id"
                  :self-tenant="true"
                  label="請求先"
                  @update:values="billingAddressChangedCallback"
                >
                  <template v-slot:append-outer>
                    <choose-billing-address-button
                      :small-button="true"
                      :self-tenant="true"
                      @choseBillingAddressCallback="choseBillingAddressCallback"
                    />
                  </template>
                </infinite-billing-auto-complete>
              </v-col>
            </v-row>
            <!-- /請求先 -->
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="cancelButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            本締め実行
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>

  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import ChooseBillingAddressButton from "@/driver/components/ChooseBillingAddressButton";
import InfiniteBillingAutoComplete from "@/driver/components/InfiniteBillingAutoComplete.vue";

export default {
  name: 'ClosingProcessDialog',
  components: {
    InfiniteBillingAutoComplete,
    ChooseBillingAddressButton
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    changeDriver: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      showTargetDatePicker: false,
      forms: {
        billing_month: null,
        closing_date_type: 'closing_last_day',
        billing_address_id: null,
      },
      /** 締め日 */
      closingDateTypes: [
        { value: 'closing_5th_day', text: '5日' },
        { value: 'closing_10th_day', text: '10日' },
        { value: 'closing_15th_day', text: '15日' },
        { value: 'closing_20th_day', text: '20日' },
        { value: 'closing_25th_day', text: '25日' },
        { value: 'closing_last_day', text: '末日' },
      ],
    }
  },
  computed: {},
  watch: {
    enableDialog () {
      this.$nextTick(() => this.$refs.closingProcessFormValidator.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      this.forms.billing_month = this.$dayjs().format("YYYY-MM");
    },
  },
  created() {},
  methods: {
    ...mapActions('DriverSalesClosingProcess', {
      createClosingProcess: 'create',
    }),
    /**
     * キャンセルボタン クリックイベント
     */
    cancelButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.closingProcessFormValidator.validate().then((result) => {
        if(result){
          this.createClosingProcess({params: this.forms}).then(() => {
            this.$emit('registerCallback')
          })
        }
      })
    },
    billingAddressChangedCallback (billing_id) {
      this.forms.billing_address_id = billing_id;
    },
    /**
     * 請求先選択ボタンからのダイアログのコールバック
     * @param item
     */
    choseBillingAddressCallback (item) {
      this.forms.billing_address_id = item.id;
    },
    /**
     * 請求月度変更　コールバック
     */
    billingMonthChangedCallback (value) {
      this.forms.billing_month = value;
    },
  }
}
</script>
